export const CHART_ICONS = {
    mobileWeb: ["desktop", "mobile-web"],
    maleFemaleIcons: ["male", "female"],
    organicPaid: ["search", "paid-keywords"],
};
